module.exports = __webpack_public_path__ + "static/img/zijianComputer.863b2322.jpg";